import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { getLicenseOppTeams } from "../../services/team.services.js";
import EntypoIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "./opponents.css"; // Custom CSS file for styling
import mainImg from "../assets/dashboard.png";
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";
import { useHistory } from "react-router-dom";

const Opponents = (props) => {
  const [opponentTeamData, setOpponentTeamData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const history = useHistory();

  const user = useSelector((state) => state.auth.user);
  const operatorTeam = useSelector((state) => state.team.selectedTeam);

 const navigateToCreateTeam = () => {
    history.push("/createopponentteam");
  };


  const handleGetAllOpponentTeams = async () => {
    try {
      setLoading(true);
      const response = await getLicenseOppTeams(
        operatorTeam?.teamId?._id,
        user?.token
      );
      setOpponentTeamData(response.data);
    } catch (error) {
      console.error("Error fetching opponent teams:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetAllOpponentTeams();
  }, []);

  const sortedArray = useMemo(() => {
    return opponentTeamData?.sort((a, b) => {
      const teamNameA = a.teamName.toUpperCase();
      const teamNameB = b.teamName.toUpperCase();
      return teamNameA < teamNameB ? -1 : teamNameA > teamNameB ? 1 : 0;
    });
  }, [opponentTeamData]);

  return (
    <div className="mainBackgroundOpp">
      <UserSidebar />
        {/* <button
          onClick={goBackHandler}
          className="actionButtonBack"
          style={{ margin: "3%" }}
        >
          <EntypoIcon />
        </button> */}
         <div className="createBtnView" onClick={navigateToCreateTeam} >
        <div className="plus" >
          <p className="plusBtnCreateTeam">+</p>
        </div>
        <p className="addTeamTxt">ADD OPPONENT TEAM</p>
      </div>
      <div className="headerOpp">
        {/* <h1 className="headerTxtOpp">SELECT AN OPPONENT</h1> */}
      </div>
      {error ? (
        <p className="noInternetTxt">Connect to internet and try again!</p>
      ) : (
        <>
          <div>
            {loading && <ChevronRightIcon />}
            {sortedArray &&
              sortedArray.map((team) => (
                <button
                  key={team._id}
                  onClick={() => {
                    console.log("Navigating with team_id:", team._id); // Log the ID
                    props.history.push({
                      pathname: "/opproster",
                      state: { team_id: team._id },
                    });
                  }}
                  className="teamView"
                >
                  <div className="subHeadView">
                    <span className="teamNameTxt">{team.teamName}</span>
                    <div className="row">
                        <span className="conferenceTxt">
                          Conference: {team.isConference ? "Yes" : "No"}
                        </span>
                    </div>
                    <ChevronRightIcon />
                  </div>
                </button>
              ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Opponents;
